import clsxm from '@/lib/clsxm';

type CarouselPageIndicatorProps = {
  currentPage: number;
  lastPage: number;
  onClick: (page: number) => void;
};

export default function CarouselPageIndicator(
  props: CarouselPageIndicatorProps
) {
  return (
    <div className='mb-4 mt-8 flex items-center justify-center gap-x-4'>
      {Array.from({ length: props.lastPage + 1 }).map((_, index) => {
        return (
          <button
            key={index}
            className={clsxm(
              'z-20 h-3 w-3 rounded-full transition-all duration-100 ease-linear',
              {
                'bg-primary': index === props.currentPage,
                'bg-gray-300': index !== props.currentPage,
              }
            )}
            onClick={() => props.onClick(index)}
            type='button'
          />
        );
      })}
    </div>
  );
}
